import gql from 'graphql-tag';

import hirerGraphqlClient from './hirer/client';
import { findAuthenticationError } from './utils';
import type {
  FetchApplicationStatusFolderByAdcentreProspectIdQuery,
  FetchApplicationStatusFolderByAdcentreProspectIdQueryVariables,
} from './fetchApplicationStatusFolderByAdcentreProspectId.hirer.graphql.generated';

const query = gql`
  query FetchApplicationStatusFolderByAdcentreProspectId(
    $input: ApplicationByAdcentreProspectIdInput!
  ) {
    applicationByAdcentreProspectId(input: $input) {
      ... on ApplicationResponseSuccess {
        result {
          statusFolder
        }
      }
      ... on ResponseError {
        error
      }
    }
  }
`;

export const fetchApplicationStatusFolderByAdcentreProspectId = async (
  variables: FetchApplicationStatusFolderByAdcentreProspectIdQueryVariables,
) => {
  const result = await hirerGraphqlClient.query<
    FetchApplicationStatusFolderByAdcentreProspectIdQuery,
    FetchApplicationStatusFolderByAdcentreProspectIdQueryVariables
  >({
    variables,
    query,
  });

  if (result.data === null && result.errors && result.errors.length > 0) {
    if (findAuthenticationError(result.errors)) {
      throw new Error('UNAUTHENTICATED');
    }
    throw new Error('Error fetching application');
  }

  if (
    result.data.applicationByAdcentreProspectId.__typename === 'ResponseError'
  ) {
    throw new Error('Error fetching application');
  }

  return result.data.applicationByAdcentreProspectId;
};
